import { render, staticRenderFns } from "./CustomSwiper.vue?vue&type=template&id=4bd70d66&scoped=true"
import script from "./CustomSwiper.vue?vue&type=script&lang=ts"
export * from "./CustomSwiper.vue?vue&type=script&lang=ts"
import style0 from "./CustomSwiper.vue?vue&type=style&index=0&id=4bd70d66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd70d66",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MerchNotify: require('/web/components/MerchNotify.vue').default})
